export default "__VITE_PUBLIC_ASSET__81b91bf9__"